import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

// Components
import { InputField } from "../../../../Components/formElements/InputField";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useDispatch, useSelector } from "react-redux";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { getMaterialList, materialBarcodeList } from "../../../../redux/feature/customer_app/customerSlice";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

const MaterialBarCodeModal = React.forwardRef((props, ref) => {
  // console.log(">>props", props);


  let materialNr = useSelector(
    (state) => state?.customerV1?.material?.materialNr
  );

  const dispatch = useDispatch();

  const [formInputs, setFormInputs] = useState({
    materialAttachments: "",
    materialImage: "",
    roiCodeMonths:"",
    roiProfileName:"",
    acAssetType:"",
    remarks:"",
    // createdOn:""
  });

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  // eslint-disable-next-line
  const units = [
    { id: 1, name: "UNIT", code: "UN", description: "UNIT" },
    { id: 2, name: "PCS", code: "PC", description: "PCS" },
    { id: 3, name: "ROLL", code: "RL", description: "ROLL" },
    { id: 4, name: "SELECT", code: "SE", description: "SELECT" },
    { id: 5, name: "KG", code: "KG", description: "KG" },
    { id: 6, name: "BOX", code: "BX", description: "BOX" },
    { id: 7, name: "PKT", code: "PK", description: "PKT" },
    { id: 8, name: "PAIR", code: "PR", description: "PAIR" },
    { id: 9, name: "PACKET", code: "PA", description: "PACKET" },
    { id: 10, name: "SET", code: "ST", description: "SET" },
    { id: 11, name: "SHEET", code: "SH", description: "SHEET" },
    { id: 12, name: "METER", code: "MT", description: "METER" },
    { id: 13, name: "CONE", code: "CN", description: "CONE" },
    { id: 14, name: "U", code: "U", description: "U" },
    { id: 15, name: "FEET", code: "FT", description: "FEET" },
    { id: 16, name: "MTR", code: "MT", description: "MTR" },
    { id: 17, name: "PCS", code: "PC", description: "PCS" },
    { id: 18, name: "KG", code: "KG", description: "KG" },
    { id: 19, name: "LTR", code: "LT", description: "LTR" },
    { id: 20, name: "SQINCH", code: "SI", description: "SQINCH" },
    { id: 21, name: "PAIRS", code: "PR", description: "PAIRS" },
    { id: 22, name: "SQFT", code: "SF", description: "SQFT" },
    { id: 23, name: "LTR", code: "LT", description: "LTR" },
    { id: 24, name: "NULL", code: "NA", description: "NULL" },
    { id: 25, name: "STICK", code: "SK", description: "STICK" },
    { id: 26, name: "RIM", code: "RM", description: "RIM" },
  ];
// eslint-disable-next-line
  const materialGroups = [
    { id: 1, name: "WALKING AIDS", code: "WA", description: "WALKING AIDS" },
    { id: 2, name: "WALKING STICK", code: "WS", description: "WALKING STICK" },
    { id: 3, name: "CRUTCHES", code: "CR", description: "CRUTCHES" },
    { id: 4, name: "WALKER", code: "WK", description: "WALKER" },
    { id: 5, name: "ROLLATORS", code: "RL", description: "ROLLATORS" },

    {
      id: 6,
      name: "RESPIRATORY CARE",
      code: "RC",
      description: "RESPIRATORY CARE",
    },
    { id: 7, name: "CPAP MACHINE", code: "CPAP", description: "CPAP MACHINE" },
    { id: 8, name: "BIPAP", code: "BIPAP", description: "BIPAP" },
    { id: 9, name: "VENTILATORS", code: "VENT", description: "VENTILATORS" },
    {
      id: 10,
      name: "OXYGEN CYLINDER",
      code: "OC",
      description: "OXYGEN CYLINDER",
    },
    {
      id: 11,
      name: "PULSE OXIMETER",
      code: "PO",
      description: "PULSE OXIMETER",
    },
    {
      id: 12,
      name: "OXYGEN CONCENTRATOR",
      code: "OXC",
      description: "OXYGEN CONCENTRATOR",
    },
    { id: 13, name: "NEBULIZER", code: "NEB", description: "NEBULIZER" },

    {
      id: 14,
      name: "PATIENT TRANSFER",
      code: "PT",
      description: "PATIENT TRANSFER",
    },
    { id: 15, name: "WHEEL CHAIRS", code: "WC", description: "WHEEL CHAIRS" },
    { id: 16, name: "STAIR CHAIR", code: "SC", description: "STAIR CHAIR" },
    { id: 17, name: "PATIENT LIFT", code: "PL", description: "PATIENT LIFT" },
    { id: 18, name: "STRETCHER", code: "STR", description: "STRETCHER" },

    { id: 19, name: "AIR MATTRESS", code: "AM", description: "AIR MATTRESS" },
    {
      id: 20,
      name: "TUBE AIR MATTRESS",
      code: "TAM",
      description: "TUBE AIR MATTRESS",
    },
    {
      id: 21,
      name: "BUBBLE AIR MATTRESS",
      code: "BAM",
      description: "BUBBLE AIR MATTRESS",
    },
    { id: 22, name: "WATER BED", code: "WB", description: "WATER BED" },

    {
      id: 23,
      name: "PATIENT CLOTHING",
      code: "PC",
      description: "PATIENT CLOTHING",
    },
    { id: 24, name: "GOWN", code: "GWN", description: "GOWN" },
    { id: 25, name: "LOWER", code: "LWR", description: "LOWER" },
    { id: 26, name: "SUIT", code: "SUT", description: "SUIT" },

    { id: 27, name: "BACK CARE", code: "BC", description: "BACK CARE" },
    { id: 28, name: "BACKREST", code: "BR", description: "BACKREST" },
    { id: 29, name: "LS BELT", code: "LSB", description: "LS BELT" },
    { id: 30, name: "TAYLOR BRACE", code: "TB", description: "TAYLOR BRACE" },

    { id: 31, name: "NECK CARE", code: "NC", description: "NECK CARE" },
    { id: 32, name: "NECKREST", code: "NR", description: "NECKREST" },
    {
      id: 33,
      name: "CERVICAL PILLOW",
      code: "CP",
      description: "CERVICAL PILLOW",
    },
    {
      id: 34,
      name: "CERVICAL COLLAR",
      code: "CC",
      description: "CERVICAL COLLAR",
    },
    {
      id: 35,
      name: "PHILADELPHIA COLLAR",
      code: "PCO",
      description: "PHILADELPHIA COLLAR",
    },

    { id: 36, name: "MOTHER CARE", code: "MC", description: "MOTHER CARE" },
    {
      id: 37,
      name: "MATERNITY BELT",
      code: "MB",
      description: "MATERNITY BELT",
    },
    { id: 38, name: "BREAST PUMP", code: "BP", description: "BREAST PUMP" },
    { id: 39, name: "BABY BLANKET", code: "BB", description: "BABY BLANKET" },
    {
      id: 40,
      name: "BREATHABLE MAC SHEET",
      code: "BMS",
      description: "BREATHABLE MAC SHEET",
    },
    {
      id: 41,
      name: "SILICONE BABY PRODUCT",
      code: "SBP",
      description: "SILICONE BABY PRODUCT",
    },

    { id: 42, name: "KNEE CARE", code: "KC", description: "KNEE CARE" },
    { id: 43, name: "KNEE CAP", code: "KCAP", description: "KNEE CAP" },
    {
      id: 44,
      name: "HINGED KNEE BRACE",
      code: "HKB",
      description: "HINGED KNEE BRACE",
    },
    {
      id: 45,
      name: "KNEE IMMOBILIZER",
      code: "KI",
      description: "KNEE IMMOBILIZER",
    },
    { id: 46, name: "ROM BRACE", code: "ROM", description: "ROM BRACE" },

    { id: 47, name: "FOOT CARE", code: "FC", description: "FOOT CARE" },
    { id: 48, name: "TOE CARE", code: "TC", description: "TOE CARE" },
    { id: 49, name: "FOOT WEAR", code: "FW", description: "FOOT WEAR" },
    { id: 50, name: "HEALTH SOCKS", code: "HS", description: "HEALTH SOCKS" },
    {
      id: 51,
      name: "SILICONE HEEL PRODUCTS",
      code: "SHP",
      description: "SILICONE HEEL PRODUCTS",
    },
    {
      id: 52,
      name: "SILICONE INSOLES",
      code: "SI",
      description: "SILICONE INSOLES",
    },

    { id: 53, name: "SCAR CARE", code: "SCAR", description: "SCAR CARE" },
  ];

    const businessLine = [
    { id: 1, name: "Sale", code: "SL", description: "Sale" },
    { id: 2, name: "Rent", code: "RE", description: "Rent" },
    ]

//     const filteredBusinessLine = businessLine.filter(
//   (item) => item.code !== formInputs?.godown
// );

  // eslint-disable-next-line
  const [validation, setValidation] = useState({});

  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);

  const [getShowFailureModal, setShowFailureModal] = useState();

   // eslint-disable-next-line
  const [disabled, setDisabled] = useState("");

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [materialMode, setMaterialMode] = useState(true);

  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line
  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line
  const [getCompanyCode, setCompanyCode] = useState([]);

  const getMasterDataFunc = async () => {
   
    let obj5 = {
      queryName: "Get_CompanyMaster_List",
      page: 1,
      per_page: 9999,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };
    await ItemService.generateCustomerQuery(obj5).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setMaterialMode(false);
    } else if (props?.show === "EDIT") {
      setMaterialMode(false);
    } else if (props?.show === "DETAILS") {
      setMaterialMode(true);
    } else {
      setMaterialMode(true);
    }
  }, [props?.show]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({
        materialAttachments: "",
        materialImage: "",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        average: "",
        quntity: "",
        pieceMeasure: "",
        unit: "",
        unitWeight: "",
        unitPrice: "",
        unitWeightModifier: "",
        unitPriceModifier: "",
        surfacePaintArea: "",
        remarks: "",
        weightPice: "",
        weightTotal: "",
        bookPrice: "",
        bookTotalPrice: "",
      });
    }
  }, [props?.show]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);


  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  useEffect(() => {
    if ((props?.show === "EDIT" || props?.show === "DETAILS") && materialNr) {
      setLoading(true); // start loading
      let obj = {
        queryName: "Get_MATERIAL_DETAIL",
        documentNumber: materialNr,
      };
      ItemService.generateCustomerQuery(obj)
        .then((res) => {
          if (res?.data?.length) {
            setFormInputs(res.data[0]);
          }
        })
        .catch(() => {
          toast.error("Failed to fetch material details!");
        })
        .finally(() => {
          setLoading(false); // stop loading
        });
    }
  }, [props?.show, materialNr]);

  const handleSubmit = async () => {
   

    let obj = {
      data: {
        ...formInputs,
        orderPriceUnit: parseFloat(formInputs?.unitPrice),
        orderUnitOfMeasure: formInputs?.unit,
        uOM: formInputs?.unit,
      },
    };

    setDisabled(true);
    // await ItemService.addMaterialHb(obj).then((item) => {
    await ItemService.addMaterial(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "Material Added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
        });
        let obj = {
          queryName: "Get_MATERIAL_LIST",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };


//   const handleUpdate = async () => {
//       const today = new Date().toLocaleDateString("en-GB"); // dd/mm/yyyy

//   let monthlyRoiAmount = formInputs.monthlyRoiAmount;

//   // 🔹 ROI calculation only for RENT
//   if (formInputs.godownCode === "RE") {
//     const unitPrice = Number(formInputs.unitPrice || 0);
//     const roiMonths = Number(formInputs.roiCodeMonths || 0);

//     monthlyRoiAmount =
//       unitPrice && roiMonths ? (unitPrice / roiMonths).toFixed(2) : 0;
//   }

//   // 🔹 Version & conversion logic
//   let version = formInputs.version || 0;
//   let conversionHistory = [...(formInputs.conversionHistory || [])];

//   const prevGodownCode = formInputs.prevGodownCode; // SALE / RENT (store this when opening edit)
//   const currentGodownCode = formInputs.godownCode;

//   if (prevGodownCode && prevGodownCode !== currentGodownCode) {
//     // 🔹 Increment version
//     version = version + 1;

//     // 🔹 Close previous conversion (if exists)
//     if (conversionHistory.length > 0) {
//       const lastIndex = conversionHistory.length - 1;
//       if (!conversionHistory[lastIndex].endDate) {
//         conversionHistory[lastIndex].endDate = today;
//       }
//     }

//     // 🔹 Add new conversion entry
//     conversionHistory.push({
//       from: prevGodownCode === "SL" ? "Sale" : "Rent",
//       to: currentGodownCode === "SL" ? "Sale" : "Rent",
//       startDate: today,
//       endDate: null,
//     });
//   }
//     //  let monthlyRoiAmount = formInputs.monthlyRoiAmount;

//   // 🔹 Only for RENT
//   if (formInputs.godownCode === "RE") {
//     const unitPrice = Number(formInputs.unitPrice || 0);
//     const roiMonths = Number(formInputs.roiCodeMonths || 0);

//     monthlyRoiAmount =
//       unitPrice && roiMonths
//         ? (unitPrice / roiMonths).toFixed(2)
//         : 0;
//   }
//   const obj = {
//     barcode: formInputs.barcode,           // filter key
//     documentNumber: formInputs.documentNumber,
//     createdByName: formInputs.createdByName,
//     status: "Created",
//     version: `v${version}`,
//     roiCodeMonths: formInputs.roiCodeMonths,
//     roiProfileName: formInputs.roiProfileName,
//     acAssetType: formInputs.acAssetType,
//     remarks: formInputs.remarks,
//     effectiveDate: formInputs.effectiveDate,
//     assetActiveInactive:formInputs.assetActiveInactive,
//     brand:formInputs.brand,
//     godown:formInputs.godown,
//     godownCode:formInputs.godownCode,
//     // monthlyRoiAmount:formInputs.monthlyRoiAmount,
//     monthlyRoiAmount: monthlyRoiAmount,
//     unitPrice:formInputs.unitPrice,
//     createdOn:formInputs.createdOn,
//     timeZone: "Asia/Calcutta",
//   };

//   console.log("Update Payload ", obj);

//   setDisabled(true);

//   // try {
//   //   const item = await ItemService.updateMaterialBarcodeItem(obj);

//   //   if (item?.status === 200) {
//   //     toast.success(item?.message || "Updated successfully");
//   //     props.onHide();

//   //     dispatch(
//   //       materialBarcodeList({
//   //         queryName: "MaterilBarcodeList",
//   //         page: 1,
//   //         per_page: 10,
//   //       })
//   //     );
//   //   } else {
//   //     toast.error(item?.message || "Please try again");
//   //   }
//   // } catch (err) {
//   //   console.error(err);
//   //   toast.error("Update failed");
//   // } finally {
//   //   setDisabled(false);
//   // }
// };


const handleUpdate = async () => {
  const today = new Date().toLocaleDateString("en-GB");

  /* ---------------- ROI LOGIC ---------------- */
  let monthlyRoiAmount = formInputs.monthlyRoiAmount;

  if (formInputs.godownCode === "RE") {
    const unitPrice = Number(formInputs.unitPrice || 0);
    const roiMonths = Number(formInputs.roiCodeMonths || 0);
    monthlyRoiAmount = unitPrice && roiMonths ? (unitPrice / roiMonths).toFixed(2) : 0;

  }
//   const isRE = formInputs.godownCode === "RE";
// const materialStatus = isRE ? "StockIn" : undefined;

  const hasHistory =
    (formInputs.barcodeERFHistory?.length || 0) > 0 ||
    (formInputs.barcodeExtendHistory?.length || 0) > 0;

  const materialStatus = hasHistory
    ? "StockOut" // highest priority
    : formInputs.godownCode === "RE"
    ? "StockIn" //  rent case
    : formInputs.materialStatus;

  /* ---------------- VERSION + CONVERSION LOGIC ---------------- */
  let versionNumber = 0;

  if (formInputs.version) {
    versionNumber = Number(formInputs.version.replace("v", ""));
  }

  let conversionHistory = [...(formInputs.conversionHistory || [])];

  const prevGodownCode = formInputs.prevGodownCode;
  const currentGodownCode = formInputs.godownCode;
   if (prevGodownCode === currentGodownCode && prevGodownCode) {
    if (currentGodownCode === "RE") {
      toast.error("Cannot convert Rent to Rent");
      return;
    }
    if (currentGodownCode === "SL") {
      toast.error("Cannot convert Sale to Sale");
      return;
    }
  }

  const isFirstTimeTracking = !prevGodownCode && conversionHistory.length === 0;
  const isConversion = prevGodownCode && prevGodownCode !== currentGodownCode;

  if (isConversion) {
    // 🔹 increment version
    versionNumber = versionNumber + 1;

    // 🔹 close previous record
    if (conversionHistory.length > 0) {
      conversionHistory = conversionHistory.map((item, index) =>
        index === conversionHistory.length - 1 && !item.endDate
          ? { ...item, endDate: today }
          : item
      );
    }

    // 🔹 add new record with version
    conversionHistory.push({
      version: `v${versionNumber}`, // version added
      from: prevGodownCode === "SL" ? "Sale" : "Rent",
      to: currentGodownCode === "SL" ? "Sale" : "Rent",
      startDate: today,
      endDate: null,
    });
  } else if (isFirstTimeTracking) {
    //  First time tracking
    versionNumber = 1;
    conversionHistory.push({
      version: `v${versionNumber}`, // version added
      from: null,
      to: currentGodownCode === "SL" ? "Sale" : "Rent",
      startDate: today,
      endDate: null,
    });
  }

  /* ---------------- PAYLOAD ---------------- */
  const obj = {
    barcode: formInputs.barcode,
    documentNumber: formInputs.documentNumber,
    createdByName: formInputs.createdByName,
    status: "Created",

    version: `v${versionNumber}`,
    conversionHistory: conversionHistory,
    prevGodownCode: currentGodownCode,

    roiCodeMonths: formInputs.roiCodeMonths,
    roiProfileName: formInputs.roiProfileName,
    acAssetType: formInputs.acAssetType,
    remarks: formInputs.remarks,

    godown: formInputs.godown,
    godownCode: formInputs.godownCode,

    unitPrice: formInputs.unitPrice,
    monthlyRoiAmount: monthlyRoiAmount,
      materialStatus: materialStatus, //


    createdOn: formInputs.createdOn,
    timeZone: "Asia/Calcutta",
  };

  // console.log("Update Payload", obj);
  // if (materialStatus === "StockOut") {
  //   toast.error("Stock already Out. Cannot update.");
  //   return;
  // }
  setDisabled(true);

  try {
    const item = await ItemService.updateMaterialBarcodeItem(obj);

    if (item?.status === 200) {
      toast.success(item?.message || "Updated successfully");
      props.onHide();

      const perPageValue = props.perPage || 10;
      const queryNameValue = props.queryName || "MaterilBarcodeList";
      dispatch(
        materialBarcodeList({
          queryName: queryNameValue,
          page: 1,
          per_page: perPageValue,
        })
      );
    } else {
      toast.error(item?.message || "Please try again");
    }
  } catch (err) {
    console.error(err);
    toast.error("Update failed");
  } finally {
    setDisabled(false);
  }
};

  // eslint-disable-next-line
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
// eslint-disable-next-line
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };


// useEffect(() => {
//   if (props?.data) {
//     setFormInputs({
//       ...props.data,           // shallow copy
//       conversionHistory: [
//         ...(props.data.conversionHistory || [])
//       ],
//       prevGodownCode: props.data.godownCode
//     });
//   }
//   getMasterDataFunc();
// }, [props.data]);
// useEffect(() => {
//   if (props?.data) {
//     setFormInputs({
//       ...props.data,
//       prevGodownCode: props.data.prevGodownCode || props.data.godownCode, // fallback for old records
//     });
//   }
//   getMasterDataFunc();
// }, [props]);

useEffect(() => {
  if (!props?.data) return;

  const hasHistory =
    (props.data.barcodeERFHistory?.length || 0) > 0 ||
    (props.data.barcodeExtendHistory?.length || 0) > 0;

  const derivedMaterialStatus = hasHistory
    ? "StockOut"
    : props.data.godownCode === "RE"
    ? "StockIn"
    : props.data.materialStatus;

  setFormInputs({
    ...props.data,
    materialStatus: derivedMaterialStatus,
    prevGodownCode:
      props.data.prevGodownCode || props.data.godownCode,
  });

  getMasterDataFunc();
}, [props?.data]);

  useEffect(() => {
    // console.log(">>getDropdownDataheader", getDropdownData);
    if (getDropdownData?.textField === "acAssetType") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        acAssetType: getDropdownData?.name,
        acAssetTypeCode: getDropdownData?.code,
        acAssetTypeDesc: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "godown") {
  setFormInputs((prev) => ({
    ...prev,
    godown: getDropdownData?.name,          
    godownCode: getDropdownData?.code,      
    godownDesc: getDropdownData?.description,
  }));
} else if (getDropdownData?.textField === "businessLine") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
    }
  }, [getDropdownData]);


  // useEffect(() => {
  //   if (props?.data) {
  //     setFormInputs(props?.data);
  //   }
  //   getMasterDataFunc();
  // }, [props]);

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.show === "CREATE"
              ? "Create Material/Product"
              : props?.show === "DETAILS"
              ? "Material/Product Detail"
              : props?.show === "EDIT"
              ? "Edit ROI"
              : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {/* accordin1 */}
              
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ROI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">ROI Information</span>
                        <span className="subHeaderTitle">
                          ROI Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Bar Code"
                            id="barcode"
                            name="barcode"
                            type="text"
                            value={formInputs?.barcode || ""}
                            onChange={onInputChange}
                            // onBlur={handleCheckValidation}
                            // disabled={
                            //   props?.show === "EDIT" ||
                            //   props?.show === "DETAILS"
                            // }
                            disabled={true}
                            error={validation?.materialCode}
                            required={true}

                          />
                        </Col>

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Material Group"
                            placeholder=""
                            data={materialGroups}
                            name="materialGroup"
                            code="materialGroupCode"
                            description="materialGroupDesc"
                            setValue={formInputs?.materialGroup || ""}
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />
                        </Col> */}

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Material Description"
                            id="materialDescription"
                            name="materialDescription"
                            type="text"
                            value={formInputs?.materialDescription || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.materialDescription}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Company Code"
                            extraLabel="Company Code"
                            placeholder=""
                            data={getCompanyCode}
                            id="companyCode"
                            iconClassName="dropdownIcon"
                            name="companyCode"
                            code="companyCodeCode"
                            description="companyCodeDesc"
                            setValue={formInputs.companyCode || ""}
                            getvalue={setDropdownData}
                            onChange={onInputChange}
                            error={validation.companyCode}
                            required={true}
                            disabled={materialMode}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="ROI Profile Name"
                            id="roiProfileName"
                            name="roiProfileName"
                            type="text"
                            value={formInputs?.roiProfileName || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.roiProfileName}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="ROI Period (Months)"
                            id="roiCodeMonths"
                            name="roiCodeMonths"
                            type="text"
                            value={formInputs?.roiCodeMonths || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.roiCodeMonths}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          {/* <InputField
                            placeholder=""
                            className="inputBox"
                            label="Applicable Category / Asset Type"
                            id="acAssetType"
                            name="acAssetType"
                            type="text"
                            value={formInputs?.acAssetType || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.acAssetType}
                          /> */}
                          <ComboboxField
                                                      className="inputBox"
                                                      label="AC Asset Type"
                                                      placeholder=""
                                                      data={materialGroups}
                                                      name="acAssetType"
                                                      code="acAssetTypeCode"
                                                      description="acAssetTypeDesc"
                                                      setValue={formInputs?.acAssetType || ""}
                                                      getvalue={setDropdownData}
                                                      disabled={materialMode}
                                                    />
                        </Col>
                      
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="createdOn Date"
                            id="createdOn"
                            name="createdOn"
                            type="date"
                            min={1999}
                            value={formInputs?.createdOn || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.createdOn}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Effective Date"
                            id="effectiveDate"
                            name="effectiveDate"
                            type="date"
                            min={1999}
                            value={formInputs?.effectiveDate || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.effectiveDate}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Brand"
                            id="brand"
                            name="brand"
                            type="text"
                            value={formInputs?.brand || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.brand}
                          />
                        </Col>
                       <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Business Line"
                            placeholder=""
                            data={businessLine}
                            name="godown"
                            code="godownCode"
                            description="godownDesc"
                            setValue={formInputs?.godown || ""}
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Quantity"
                            id="purchaseQuantity"
                            name="purchaseQuantity"
                            type="text"
                            value={formInputs?.purchaseQuantity || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.purchaseQuantity}
                          />
                        </Col> */}

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit"
                            id="unit"
                            name="unit"
                            type="text"
                            value={formInputs?.unit || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unit}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Unit"
                            placeholder=""
                            data={units}
                            name="unit"
                            code="unitCode"
                            description="unitDesc"
                            setValue={formInputs?.unit || ""}
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />
                        </Col> */}

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Rate"
                            id="unitPrice"
                            name="unitPrice"
                            type="text"
                            value={formInputs?.unitPrice || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitPrice}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="IPHSLR Price"
                            id="iphslrPrice"
                            name="iphslrPrice"
                            type="text"
                            value={formInputs?.iphslrPrice || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.iphslrPrice}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="PCDLR Price"
                            id="pcdlrPrice"
                            name="pcdlrPrice"
                            type="text"
                            value={formInputs?.pcdlrPrice || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.pcdlrPrice}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="MRP"
                            id="mrPrice"
                            name="mrPrice"
                            type="text"
                            value={formInputs?.mrPrice || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.mrPrice}
                            required={true}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit weight Modifier"
                            id="unitWeightModifier"
                            name="unitWeightModifier"
                            type="text"
                            value={formInputs?.unitWeightModifier || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitWeightModifier}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit Price Modifier"
                            id="unitPriceModifier"
                            name="unitPriceModifier"
                            type="text"
                            value={formInputs?.unitPriceModifier || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitPriceModifier}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Surface/Paint Area"
                            id="surfacePaintArea"
                            name="surfacePaintArea"
                            type="number"
                            value={formInputs?.surfacePaintArea || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            // error={validation?.surfacePaintArea}
                          />
                        </Col> */}
                     
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            placeholder=""
                            className="inputBox"
                            label="Remarks"
                            id="remarks"
                            name="remarks"
                            value={formInputs?.remarks || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.remarks}
                          />
                        </Col>
                           <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                                              >
                                                <div>
                                                  <label
                                                    className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                    htmlFor="assetActiveInactive"
                                                  >
                                                    Active/Inactive
                                                  </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                  <input
                                                    className="form-check-input custom-switch"
                                                    type="checkbox"
                                                    role="switch"
                                                    name="assetActiveInactive"
                                                    id="assetActiveInactive"
                                                    checked={formInputs?.assetActiveInactive || false}
                                                    onChange={(e) =>
                                                      setFormInputs((prev) => ({
                                                        ...prev,
                                                        assetActiveInactive: e.target.checked,
                                                      }))
                                                    }
                                                    // disabled={editMode}
                                                  />
                                                  <span className="ms-2">
                                                    {formInputs?.assetActiveInactive ? "Active" : "Inactive"}
                                                  </span>
                                                </div>
                                              </Col>
                       

                        {/* <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Pice"
                        id="weightPice"
                        name="weightPice"
                        type="text"
                        value={formInputs.weightPice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Total"
                        id="weightTotal"
                        name="weightTotal"
                        type="text"
                        value={formInputs.weightTotal || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Price"
                        id="bookPrice"
                        name="bookPrice"
                        type="text"
                        value={formInputs.bookPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Total Price"
                        id="bookTotalPrice"
                        name="bookTotalPrice"
                        type="text"
                        value={formInputs.bookTotalPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col> */}
                        <Col xs={12} md={12} lg={12}></Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {props.show !== "DETAILS" && (
                <div className="space-y-4">
                  <Row className="justify-end">
                    <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                      <button
                        type="button"
                        onClick={() => props.onHide()}
                        className="btn btn-danger mt-4 w-full justify-center rounded-md"
                      >
                        Cancel
                      </button>
                    </Col>
                    {props.show === "CREATE" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleSubmit}
                          disabled={materialMode}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Save
                        </button>
                      </Col>
                    )}
                    {props.show === "EDIT" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleUpdate}
                          disabled={materialMode}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Update
                        </button>
                      </Col>
                    )}
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className="commLeftRightPadding"
                    >
                      {/* <p className="errorMsg"> {errorMsg} </p> */}
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={failureModalData}
        requiredfields={getErrorFields}
      />
    </>
  );
});

export default MaterialBarCodeModal;
